<template>
    <el-dialog title="编辑分类" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form" ref="form">


         <el-form-item label="所属分类" :label-width="formLabelWidth">
            <el-select v-model="form.parent_id">
              <el-option label="顶级分类" :value="0"></el-option>
              <el-option :value="cat.category_id" v-if="cat.category_id!=form.category_id" :label="cat.name" :key="cat.category_id" v-for="cat in addform"></el-option>
            </el-select>
          </el-form-item>

            <el-form-item label="分类名称" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="分类副标" :label-width="formLabelWidth">
              <el-input v-model="form.name2" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="标签" prop="labels" :label-width="formLabelWidth">
              <el-input type="input" v-model="form.labels" autocomplete="off" placeholder="请输入标签" class="max-w460"></el-input>
               <div class="gray">多个标签，空格隔离；如：111 222 333</div>
            </el-form-item>

            <el-form-item label="推荐："  :label-width="formLabelWidth">
              <el-radio-group v-model="form.is_recommend">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>


            <el-form-item label="排序" :label-width="formLabelWidth">
                <el-input type="number" v-model="form.sort" autocomplete="off"></el-input>
            </el-form-item>


            <el-form-item label="ban图片：" :label-width="formLabelWidth" prop="image">
              <div slot="label">ban图片：<gm-tips content="建议尺寸750x270" /></div>
              <el-row>
                <el-button icon="el-icon-picture-outline" @click="openUpload({ type: 'image' })">选择图片
                </el-button>
                <div class="draggable-list">
                  <div v-if="form.image !== ''" class="img item">
                    <img :src="form.image" width="100" height="100" alt="image"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgimage"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </el-row>
            </el-form-item>


            <el-form-item label="列表图片：" :label-width="formLabelWidth" prop="imagelist">
              <div slot="label">列表图片：<gm-tips content="建议尺寸304x227" /></div>
              <el-row>
                <el-button icon="el-icon-picture-outline" @click="openUploadlist({ type: 'imagelist' })">选择图片
                </el-button>
                <div class="draggable-list">
                  <div v-if="form.imagelist !== ''" class="img item">
                    <img :src="form.imagelist" width="100" height="100" alt="imagelist"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgimagelist"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </el-row>
            </el-form-item>



        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editCategory" :loading="loading">确 定</el-button>
        </div>

        <!--上传图片组件-->
        <Upload v-if="isupload" :isupload="isupload" type="image" @returnImgs="returnImgsFunc">上传图片</Upload>
        <Upload v-if="isuploadlist" :isupload="isuploadlist" type="image" @returnImgs="returnImgsFunclist">上传图片</Upload>
    </el-dialog>
</template>

<script>
import MaterialApi from '@/api/material2.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogVisible: false,
                loading: false,

                isupload: false,
                isuploadlist: false,
            };
        },
        props: ['open_edit','form','addform'],
        created() {
            this.dialogVisible = this.open_edit;
            console.log(this.form);
        },
        methods: {
            /*修改分类*/
            editCategory() {
                let self = this;
                let params = this.form;
                self.loading = true;
                MaterialApi.editCategory(params, true)
                    .then(data =>
                    {
                      self.loading = false;
                        self.$message({
                            message: '恭喜你，修改成功',
                            type: 'success'
                        });
                        self.dialogFormVisible(true);

                    })
                    .catch(error =>
                    {
						self.loading = false;
                    });
            },

            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            },


            /*上传封面图*/
            openUpload(e) {
              this.isupload = true;
            },
            /*获取图片*/
            returnImgsFunc(e) {
              if (e != null && e.length > 0) {
                this.form.image = e[0].file_path;
              }
              this.isupload = false;
            },
            /* 删除商品分享图 */
            deleteImgImage() {
              this.form.image = "";
              this.isupload = false;
            },


            /*上传封面图*/
            openUploadlist(e) {
              this.isuploadlist = true;
            },
            /*获取图片*/
            returnImgsFunclist(e) {
              if (e != null && e.length > 0) {
                this.form.imagelist = e[0].file_path;
              }
              this.isuploadlist = false;
            },
            /* 删除商品分享图 */
            deleteImgImagelist() {
              this.form.imagelist = "";
              this.isuploadlist = false;
            },

        }
    };
</script>

<style>

  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/material2/category/part/Edit.vue